import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // or your global styles

// FIX: Import BrowserRouter from 'react-router' to match your components
import { BrowserRouter } from 'react-router'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);